// theme/scripts/components/pockets.js

import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';
import SelectComponent from '../common/select';
import { CustomizeContext } from '../contexts/customize';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/get_pocket'
});

const productId = document.getElementById('mtm-customize')?.dataset?.productId;
const mtmBodyType = document.getElementById('mtm-customize')?.dataset?.mtmBodyType;

const MtmPocket = ({ setPocketData }) => {
  const [list, setList] = useState([]);
  const [error, setError] = useState(null);
  const { setCustomizes } = useContext(CustomizeContext);

  useEffect(() => {
    if (mtmBodyType === 'formal') return;

    let mounted = true;
    const getList = async () => {
      try {
        const response = await client.get('?product_id=' + productId);
        if (!mounted) return;

        const pocketList = response.data.result || [];
        setList(pocketList);

        const reorderRaw = sessionStorage.getItem('reorder_properties');
        if (!reorderRaw) return;

        const reorderData = JSON.parse(reorderRaw);
        const reorderLabel = reorderData._Pocket;

        const matched = pocketList.find((item) => item.label === reorderLabel);
        if (!matched) {
          setError(`Saved value: Pocket "${reorderLabel}" does not exist in this fabric. Please select again.`);
          return;
        }

        if (matched) {
          // CustomizeContext に反映
          setCustomizes((prev) => ({
            ...prev,
            pocket: {
              id: matched.id,
              label: matched.label,
              value: matched.value,
              img: matched.image_url,
            },
          }));

          // Embroidery などで参照するために setPocketData にも渡す
          if (setPocketData) {
            setPocketData({
              id: matched.id,
              value: matched.value,
            });
          }
        }
      } catch (err) {
        setError('❌ APIエラーによりポケット情報を取得できませんでした。');
      }
    };

    getList();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
      const reorderRaw = sessionStorage.getItem('reorder_properties');
      if (!reorderRaw) return;
  
      const el = document.getElementById('mtm-pocket');
      if (el) {
        el.classList.add('active');
        el.nextElementSibling?.classList.add('active');
      }
    }, [list]);

  if (!list || list.length === 0) return null;

  return (
    <div className="mtm-item__wrapper" id="mtm-pocket">
      <h3 className="mtm-item__title">POCKETS</h3>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div className="mtm-item__selects row row-cols-2 row-cols-md-3">
        {list.map((item, ind) => (
          <SelectComponent
            setOptionData={setPocketData}
            isSetAttributes
            item={item}
            ind={ind}
            name="pocket"
            key={`${item.value}-${ind}`}
          />
        ))}
      </div>
    </div>
  );
};

export default MtmPocket;
